import { accountHomeViewConstants } from "../_constants";

export function accountHomeView(
  state = { fetchingDetail: false, detail: {} },
  action
) {
  switch (action.type) {
    case accountHomeViewConstants.APPLIANCES_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.APPLIANCES_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.APPLIANCES_FAILURE:
      return {
        ...state,
      };

    case accountHomeViewConstants.GET_APPLIANCE_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.GET_APPLIANCE_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.GET_APPLIANCE_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    case accountHomeViewConstants.SET_APPLIANCE_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.SET_APPLIANCE_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.SET_APPLIANCE_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    case accountHomeViewConstants.GET_HOLIDAY_MODE_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.GET_HOLIDAY_MODE_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.GET_HOLIDAY_MODE_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    case accountHomeViewConstants.SET_HOLIDAY_MODE_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.SET_HOLIDAY_MODE_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.SET_HOLIDAY_MODE_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    case accountHomeViewConstants.GET_DO_NOT_DISTURB_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.GET_DO_NOT_DISTURB_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.GET_DO_NOT_DISTURB_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    case accountHomeViewConstants.SET_DO_NOT_DISTURB_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.SET_DO_NOT_DISTURB_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.SET_DO_NOT_DISTURB_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    case accountHomeViewConstants.GET_TARIFF_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.GET_TARIFF_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.GET_TARIFF_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    case accountHomeViewConstants.SET_TARIFF_REQUEST:
      return {
        ...state,
        fetchingDetail: true,
      };
    case accountHomeViewConstants.SET_TARIFF_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail,
      };

    case accountHomeViewConstants.SET_TARIFF_FAILURE:
      return {
        fetchingDetail: false,
        ...state,
      };
    default:
      return state;
  }
}
